
<VueLoading type="spiningDubbles" color="#6f6f6f" :size="{ width: '80px', height: '80px' }" />
